import { FormField, FormInput } from '@/_components';
import { BusinessDisciplinesSelect } from '@/_pages/settings/business-disciplines/shared/components';
import { DepartmentSelect } from '@/_pages/settings/departments/shared/components';
import { LocationsSelect } from '@/_pages/settings/preferred-locations/shared/components/locations-combo';
import { PreferredRelationsShipsSelect } from '@/_pages/settings/preferred-relationships/shared';
import { SalaryGradesSelect } from '@/_pages/settings/salary-grades/shared/components';

import { useJobPositionFormContext } from './use-form';

export function FormFields({ isEditable = true, autoFocus = false }: { isEditable?: boolean; autoFocus?: boolean }) {
  const form = useJobPositionFormContext();

  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            label="Job Position (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <FormField
        control={form.control}
        name="salary_grade"
        render={({ field }) => (
          <SalaryGradesSelect
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            value={field.value}
            label="Salary Grade"
            onValueChange={field.onChange}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="department"
        render={({ field }) => (
          <DepartmentSelect
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            value={field.value}
            label="Department"
            onValueChange={field.onChange}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="business_discipline"
        render={({ field }) => (
          <BusinessDisciplinesSelect
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            value={field.value}
            label="Business Discipline"
            onValueChange={field.onChange}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="preferred_relationship"
        render={({ field }) => (
          <PreferredRelationsShipsSelect
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            value={field.value}
            label="Preferred Relationship"
            onValueChange={field.onChange}
            disabled={!isEditable}
          />
        )}
      />

      <FormField
        control={form.control}
        name="preferred_location"
        render={({ field }) => (
          <LocationsSelect
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
            value={field.value}
            label="Preferred Location"
            onValueChange={field.onChange}
            disabled={!isEditable}
          />
        )}
      />
    </>
  );
}
